import React, { useEffect, useState } from "react";
import axios from "axios";
import { io } from "socket.io-client";
import ExportButtons from "./ExportButtons";

const socket = io("http://3.236.217.225:5001");

export default function EvaluacionesClase() {
  const [grupos, setGrupos] = useState([]);
  const [grupoSeleccionado, setGrupoSeleccionado] = useState(null);
  const [evaluaciones, setEvaluaciones] = useState([]);
  const [promedio, setPromedio] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchGrupos = async () => {
    const { data } = await axios.get("http://3.236.217.225:5001/api/profesores/mis-grupos");
    setGrupos(data);
    if (data.length > 0) setGrupoSeleccionado(data[0].id);
  };

  const fetchEvaluaciones = async (grupoId) => {
    if (!grupoId) return;
    setLoading(true);
    try {
      const { data } = await axios.get(`http://3.236.217.225:5001/api/evaluaciones/grupo/${grupoId}`);
      setEvaluaciones(data);
      calcularPromedio(data);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const calcularPromedio = (data) => {
    const suma = data.reduce((acc, e) => acc + (e.nota || 0) * (e.peso || 1), 0);
    const pesoTotal = data.reduce((acc, e) => acc + (e.peso || 1), 0);
    setPromedio(pesoTotal > 0 ? (suma / pesoTotal).toFixed(2) : 0);
  };

  const handleNotaChange = async (id, nuevaNota) => {
    const ev = evaluaciones.find(e => e.id === id);
    await axios.post(`http://3.236.217.225:5001/api/evaluaciones`, {
      estudiante_id: ev.estudiante_id,
      tipo: ev.tipo,
      descripcion: ev.descripcion,
      nota: nuevaNota,
      peso: ev.peso,
      usuario_id: 1 // ID profesor
    });
  };

  useEffect(() => {
    fetchGrupos();
  }, []);

  useEffect(() => {
    fetchEvaluaciones(grupoSeleccionado);
    socket.on("evaluacionActualizada", () => fetchEvaluaciones(grupoSeleccionado));
    return () => socket.off("evaluacionActualizada");
  }, [grupoSeleccionado]);

  if (loading) return <p>Cargando evaluaciones...</p>;

  return (
    <div>
      <h2>Evaluaciones Integrales del Grupo</h2>

      <label>Seleccionar Grupo: </label>
      <select value={grupoSeleccionado || ""} onChange={e => setGrupoSeleccionado(e.target.value)}>
        {grupos.map(g => <option key={g.id} value={g.id}>{g.nombre}</option>)}
      </select>

      <ExportButtons data={evaluaciones} />

      <table border="1" cellPadding="5" style={{ width: "100%", marginTop: "10px" }}>
        <thead>
          <tr>
            <th>Estudiante</th>
            <th>Actividad</th>
            <th>Tipo</th>
            <th>Peso</th>
            <th>Nota</th>
            <th>Medalla</th>
            <th>Alertas</th>
          </tr>
        </thead>
        <tbody>
          {evaluaciones.map(e => (
            <tr key={e.id}>
              <td>{e.estudiante_nombre}</td>
              <td>{e.descripcion}</td>
              <td>{e.tipo}</td>
              <td>{e.peso}</td>
              <td>
                <input
                  type="number"
                  value={e.nota || ""}
                  onChange={ev => handleNotaChange(e.id, parseFloat(ev.target.value))}
                />
              </td>
              <td>{e.nota >= 90 ? "🏅" : ""}</td>
              <td>{e.nota < 60 ? "⚠️ Bajo rendimiento" : ""}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p>Promedio ponderado del grupo: {promedio}</p>
    </div>
  );
}
